import {useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';

// Po każdej nawigacji w aplikacji (link, Wstecz, Dalej) fokus trafia na nagłówek h1 nowej strony,
// żeby czytnik ekranu ją ogłosił. Przy pierwszym wczytaniu fokus zostaje tam, gdzie ustawi go przeglądarka.
// Komponent jest montowany raz w App, dlatego pamięta, czy pierwsze wczytanie już minęło.
export const FokusPoNawigacji = () => {
    const location = useLocation();
    const pierwszeWczytanie = useRef(true);

    useEffect(() => {
        if (pierwszeWczytanie.current) {
            pierwszeWczytanie.current = false;
            return;
        }
        const main = document.getElementById('tresc');
        if (!main) return;
        const cel: HTMLElement = main.querySelector('h1') || main;
        cel.setAttribute('tabindex', '-1');
        cel.focus();
    }, [location.pathname]);

    return null;
}

export default FokusPoNawigacji
